import type { IconSvgObject } from './types';

const FilterMailSquareIcon: IconSvgObject = [
  ["path", { d: "M8.50006 12H15.5001M10.5001 15.5H13.5001M7.50006 8.5H16.5001", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default FilterMailSquareIcon;
